import { ContactsAddress } from '@components/molecules/ContactsAddress';
import { ContactsTop } from '@components/molecules/ContactsTop';
import { ContactsForm } from '@components/organisms/ContactsForm';
import { ContactsLinks } from '@components/organisms/ContactsLinks';

import {
  ContactsFragment,
  LayoutFragment,
} from '@prismic/gqlTypes/prismicOperations';
import React from 'react';
import { useIntl } from 'react-intl';

import { useSendContactUsMutation } from '@sdk/gqlTypes/generatedHooks';

import * as S from './styles';

interface IProps {
  contacts?: ContactsFragment;
  layout: LayoutFragment;
}

export const Page: React.FC<IProps> = ({ contacts, layout }) => {
  const intl = useIntl();
  // TODO: Fix the mutation
  const [sendContactUsMutation, { data, loading }] = useSendContactUsMutation(
    {}
  );

  if (data && data.sendContactUs.errors.length === 0) {
    return (
      <S.SuccessMessage>
        <p>
          {intl.formatMessage({ defaultMessage: 'Thank you!', id: 'aYIUar' })}
        </p>
        <p>
          {intl.formatMessage({
            defaultMessage: 'Your message has been successfully sent.',
            id: 'emIUms',
          })}
        </p>
      </S.SuccessMessage>
    );
  }

  return (
    <div className="contacts-page">
      <ContactsTop contacts={contacts} />
      <S.Background>
        <S.Content>
          <ContactsLinks contacts={contacts} layout={layout} />
          <S.Form>
            <S.Title>{contacts?.form_title}</S.Title>
            <ContactsForm
              defaultValues={{
                customerEmail: '',
                message: '',
                subject: '',
              }}
              handleSubmit={(values) =>
                sendContactUsMutation({
                  variables: {
                    email: values.customerEmail,
                    message: values.message,
                    subject: values.subject,
                  },
                })
              }
              errorsFromBackend={data?.sendContactUs.errors}
            />

            {loading && (
              <S.Loader>
                {intl.formatMessage({
                  defaultMessage: 'Loading....',
                  id: 'YixU0V',
                })}
              </S.Loader>
            )}
          </S.Form>
        </S.Content>
      </S.Background>
      <ContactsAddress contacts={contacts} />
    </div>
  );
};

Page.displayName = 'ContactsPage';

export default Page;
